import {ListView, createInitialState} from "../ListView";
import {FormInput} from "../../form/FormInput";
import {FormGroup} from "../../form/FormGroup";
import {Form, FormListener} from "../../form/Form";
import {DashboardUserService, DASHBOARD_USER_SERVICE_NAME} from "../../../service/DashboardUserService";
import * as React from "react";
import {User, ListUsersRequest} from "../../../../generated/protocol";
import {PagerModel} from "../../list/PagerModel";
import {UserService, USER_SERVICE_NAME} from "../../../service/admin/UserService";
import {EntityDataTable} from "../../list/EntityDataTable";
import {AppCtx} from "../../../ioc/ApplicationContext";
import {ListUtils} from "../../list/ListUtils";
import {LoadingViewState} from "../RouterView";
import * as _ from "lodash";
import {kernel} from "../../../ioc/IOCHelper";
import {Validators} from "../../form/Validators";
import {RUGPanel} from "../../attributes/RUGPanel";
import {RemovableTagModal} from "../../util/RemovableTagModal";

interface State extends LoadingViewState {
    listRequest?: ListUsersRequest;
    form?: ListUsersRequest;
    operators?: Map<number, string>;
    validationMap?: any;
}

export class UserListView extends ListView<State, ListUsersRequest> implements FormListener<ListUsersRequest> {

    columns = [
        {property: "userId", name: "ID", orderBy: "ID"},
        {property: "userName", name: "Username", orderBy: "userName"},
        {property: "externalUserId", name: "XID", orderBy: "externalUserId"},
        {property: "operatorId", name: "Operator", renderer: this.renderOperator.bind(this)},
        {property: "RUGs", name: "RUGs", renderer: this.renderTags.bind(this)}
    ];
    actions = [
        {id: "view", name: "View", className: "btn btn-primary btn-sm", iconClassName: "fa fa-eye"}
    ];


    userService: UserService;

    constructor(props) {
        super(props, "/users");

        this.state = {form:{limit: 50, orderBy: "ID"}, validationMap:{}};
        this.userService = kernel.get<UserService>(USER_SERVICE_NAME);
    }

    loadContent(): Promise<any> {
        var dashboardUserService = AppCtx.resolve<DashboardUserService>(DASHBOARD_USER_SERVICE_NAME);
        return dashboardUserService.getLoginOperators().then(operators => {
            let operatorNames = new Map<number, string>();
            operators.forEach(o => operatorNames.set(o.operatorId, o.name));
            this.setState({"operators": operatorNames});
        });
    }

    formDidUpdate(formModel: ListUsersRequest, validationMap: any): void {
        this.setState({"form": formModel, validationMap: validationMap});
    }

    onSubmit(): void {
        let listRequest;
        if (this.state.listRequest) {
            listRequest = _.clone(this.state.listRequest);
        } else {
            listRequest = _.clone(this.defaultListRequest);
        }

        listRequest.offset = 0;
        listRequest.orderBy = "ID";
        listRequest.operatorId = this.state.form.operatorId;
        listRequest.userId = this.state.form.userId;
        listRequest.userName = this.appendWildCardInRequestUserName(this.state.form.userName);

        this.updateListState(listRequest);
    };

    private appendWildCardInRequestUserName(requestUserName: string): string {
        if (!requestUserName || requestUserName == "%%")
            return "";

        if (requestUserName[0] != "%")
            requestUserName = "%" + requestUserName;

        if (requestUserName[requestUserName.length-1] != "%")
            requestUserName = requestUserName + "%";

        return requestUserName;
    }

    renderOperator(property: string, name: string, user: any): string {
        let ops = this.state.operators;
        if (ops == null || !ops.has(user.operatorId)) {
            return user.operatorId;
        } else {
            return ops.get(user.operatorId) + " (" + user.operatorId + ")";
        }
    }

    renderTags(property: string, name: string, user: any) {
        let tags = [];
        for (let key in user.attributes) {
            if (key.substr(0, RUGPanel.RUG_PREFIX.length) == RUGPanel.RUG_PREFIX) {
                let tag = RUGPanel.decodeTag(key);
                tags.push(<RemovableTagModal onDelete={this.handleRUGDelete.bind(this, user, key)} label={"Remove"}
                                             title={"Confirm Removal"} description={user.userName + " from RUG " + tag}
                                             tagName={tag}/>);
            }
        }
        return tags;
    }

    handleRUGDelete(user: User, key: string) {
        return this.userService.removeAttribute(user.userId, key).then(() => {
            delete user.attributes[key];
            this.updateListState(this.state.listRequest);
        });
    }

    pagerChanged(pager: PagerModel) {
        var listRequest = ListUtils.toListRequest(this.state.listRequest, pager);
        this.setState({listRequest: listRequest});
    }

    onAction(item: User, action: string) {
        var win = window.open("/dashboard/#/user/" + item.userId, '_blank');
        win.focus();
    }

    getTitle() {
        return "User";
    }


    renderContent() {
        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>{this.getTitle()}</h1>
                    </div>
                </div>

                <div className="wrapper wrapper-content">

                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>Filter Users</h5>
                        </div>
                        <div className="ibox-content">
                            <Form className="form-horizontal" formListener={this} modelObject={this.state.form}
                                  validationMap={this.state.validationMap}>
                                <FormGroup className="form-group" model="userId">
                                    <label className="col-lg-2 control-label">User Id</label>
                                    <div className="col-lg-10">
                                        <FormInput className="form-control" model="userId" type="integer"
                                                   validators={[Validators.integer()]}/>
                                        <span className="help-block m-b-none">The Poker systems internal id.</span>
                                    </div>
                                </FormGroup>
                                <FormGroup className="form-group" model="userName">
                                    <label className="col-lg-2 control-label">Free Text</label>
                                    <div className="col-lg-10">
                                        <FormInput className="form-control" model="userName" type="text"/>
                                        <span className="help-block m-b-none">Search users by nick name and external id.</span>
                                    </div>
                                </FormGroup>

                                <div className="form-group">
                                    <div className="col-lg-offset-2 col-lg-10">
                                        <input className="btn btn-primary" value="List Users" type="submit"/>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>

                    {this.renderTable()}

                </div>
            </div>
        );
    }

    private renderTable() {
        if (!this.state.listRequest) return;

        return (<EntityDataTable
            service={this.userService}
            onPagerChange={this.pagerChanged.bind(this)}
            columns={this.columns}
            listRequest={this.state.listRequest}
            onAction={this.onAction.bind(this)}
            actions={this.actions}
        />);
    }

}



// WEBPACK FOOTER //
// ./src/app/ui/view/user/UserListView.tsx